<template>
  <div v-if="visible" class="im-chat-btn" @click="handleOpen">
    <img class="chat-icon" src="../../assets/image/header/chat.svg" />
    <img
      class="chat-icon-active"
      src="../../assets/image/header/chat-active.svg"
    />
    项目聊天室
    <span class="count-tips" v-if="newNumber">{{
      newNumber > 99 ? '99+' : newNumber
    }}</span>
  </div>
</template>

<script setup lang="ts">
// @ts-nocheck
import Imsdk from '@transn/im-sdk';
import { ref } from 'vue';
import { nextTick, onMounted } from 'vue';

// 角色的颜色配置
const roleColors = [
  {
    role: '总控',
    textColor: '#B762E3',
    borderColor: '#CEA1FD',
    bgColor: '#EDE6FF'
  },
  {
    role: '质控',
    textColor: '#FF9615',
    borderColor: '#FDD4A1',
    bgColor: '#FFF4E8'
  },
  {
    role: 'PE',
    textColor: '#2C8AF7',
    borderColor: '#BEDCFF',
    bgColor: '#D8EAFF'
  },
  {
    role: 'PM',
    textColor: '#14BB8C',
    borderColor: '#A4E4D2',
    bgColor: '#E7FFF8'
  }
];

const props = defineProps<{
  userId: string;
}>();

const newNumber = ref(0);
const imInstance = ref();
const visible = ref(false);

function handleOpen() {
  nextTick(() => {
    imInstance.value.setVisible(true);
  });
}

onMounted(async () => {
  imsdkChat();
});

function imsdkChat() {
  const imsdk = new Imsdk(
    {
      user_code: props.userId, //'WE1203903991740324446TR',
      initType: 'list',
      roleColor: roleColors
    },
    () => {},
    {
      onSuccess: (data) => {
        visible.value = data.hasGroup;
      },
      onError: () => {},
      onUnreadUpdate: (number) => {
        newNumber.value = number;
      }
    }
  );
  imInstance.value = imsdk;
}
</script>

<style src="./index.scss" scoped />
